/**
 * renewal 콘텐츠로 서빙하는 로그인 이전 라우트의 단일 원본.
 *
 * app.vue 의 익명 마케팅 라우트 게이트, sitemap, 테스트가 모두 이 목록을 본다.
 * 라우트를 추가할 때 한 곳만 고치면 되고, 빠뜨리면 그 페이지는 SSR 에서 빈 셸이 나간다
 * (= 검색엔진에 아무것도 안 보인다).
 *
 * `/` 는 여기에 없다 — Nuxt 의 `index` 라우트로 RouteName.Root 가 이미 허용한다.
 */
export const RENEWAL_ROUTE_NAMES = [
    'skills',
    'aifluent',
    'skillcertify',
    'skillfit',
    'skillpath',
    'skillcamp',
    'axpresso',
    'ax-build',
    'ax-grow',
    'why-codepresso',
    'cases',
    'company',
] as const;

export type RenewalRouteName = (typeof RENEWAL_ROUTE_NAMES)[number];

/** sitemap 에 올릴 경로. 파일명이 곧 라우트라 이름과 1:1 이다. */
export const RENEWAL_ROUTE_PATHS: string[] = RENEWAL_ROUTE_NAMES.map((name) => `/${name}`);

/**
 * 이 라우트 이름이 renewal 페이지인가.
 *
 * `route.name.split('-')[0]` 같은 접두 비교를 쓰지 않는다 — `ax-build` 가 `ax` 로
 * 잘려 엉뚱한 판정이 된다. 이름 전체를 그대로 본다.
 */
export function isRenewalRouteName(name: unknown): boolean {
    return typeof name === 'string' && (RENEWAL_ROUTE_NAMES as readonly string[]).includes(name);
}
